export default __webpack_public_path__ + "static/media/598.996f6287.jpg";